import { MainLayout } from '../layouts/MainLayout';
import { NotificationList } from '../components/NotificationList';
import { useNotifications } from '../hooks/useApi';
import { useRequireAuth } from '../hooks/useRequireAuth';
import { Loader2, AlertCircle } from 'lucide-react';

export function NotificationsPage() {
  const { isLoading: isAuthLoading } = useRequireAuth();
  
  const { data, isLoading, error } = useNotifications();

  if (isAuthLoading || isLoading) {
    return (
      <MainLayout>
        <div className="flex flex-col items-center justify-center py-16">
          <Loader2 className="w-10 h-10 animate-spin text-emerald-600 mb-4" />
          <p className="text-gray-600">Loading notifications...</p>
        </div>
      </MainLayout>
    );
  }

  if (error) {
    return (
      <MainLayout>
        <div className="flex flex-col items-center justify-center py-16">
          <div className="p-4 bg-red-50 rounded-full mb-4">
            <AlertCircle className="w-10 h-10 text-red-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Failed to load notifications</h3>
          <p className="text-gray-600">{error.message}</p>
        </div>
      </MainLayout>
    );
  }

  const notifications = data || [];

  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Notifications</h1>
          <p className="text-gray-600 mt-1">Stay updated on your availability alerts</p>
        </div>

        <NotificationList notifications={notifications} />
      </div>
    </MainLayout>
  );
}
